import { AxiosResponse } from 'axios';

import { fetchReport } from '../../services/reports';
import { ReportOption } from '../../interfaces/reports.interface';

// Extracts the server-provided filename from a Content-Disposition header, if present.
export const parseFilenameFromContentDisposition = (disposition?: string): string | null => {
  if (!disposition) return null;
  const encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
  if (encoded) return decodeURIComponent(encoded[1].replace(/"/g, '').trim());
  const plain = /filename=("?)([^";]+)\1/i.exec(disposition);
  return plain ? plain[2].trim() : null;
};

// Triggers a browser download for a Blob payload.
export const downloadBlob = (data: Blob, filename: string) => {
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Downloads a blob axios response, preferring the server filename and falling back otherwise.
export const downloadBlobResponse = (response: AxiosResponse<Blob>, fallbackFilename: string) => {
  const filename = parseFilenameFromContentDisposition(response.headers?.['content-disposition']) || fallbackFilename;
  downloadBlob(response.data, filename);
};

export const downloadReport = async (reportOption: ReportOption, reportName: string) => {
  try {
    const data = await fetchReport(reportOption);
    const blob = new Blob([data], { type: 'text/csv' });
    const date = new Date().toISOString().split('T')[0];
    const filename = `${reportName.toLowerCase().replace(/\s+/g, '-')}-${date}.csv`;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download the report:', error);
  }
};